/**
 * 定数記録用ファイル
 */
// tslint:disable-next-line:no-namespace
export namespace Constants {
    // 環境設定 start
    // honban order
    // export const DOMAIN_URL: string = 'https://www.e-cydeen-saas.gks.fwd.ne.jp';
    // export const PROJECT_URL: string = '/uketsukeoshiga/services';

    // honban accepter
    export const DOMAIN_URL: string = 'https://www.e-cydeen-saas.sus.fwd.ne.jp';
    export const PROJECT_URL: string = '/uketsukeashiga/services';

    // ct
    // export const DOMAIN_URL: string = 'http://192.168.5.202';
    // export const PROJECT_URL: string = '/cydeen2shiga/services';

    // local
    // export const DOMAIN_URL: string = 'http://localhost:8090';
    // export const PROJECT_URL: string = '/cydeen2shiga/services';
    // 環境設定 end

    export const KANRI_URL: string = DOMAIN_URL + PROJECT_URL + '/kanri';
    export const UKETSUKE_URL: string = DOMAIN_URL + PROJECT_URL + '/uketsuke';

    export const PATH_TAIL_INIT: string = '/init';
    export const PATH_TAIL_CREATE: string = '/create';
    export const PATH_TAIL_UPDATE: string = '/update';

    /** 管理者権限 */
    export const ROLE_CYDEEN2_ADMIN: string = 'ROLE_CYDEEN2_ADMIN';

    /** 運用管理操作権限 */
    export const ROLE_KANRI_ORG_READ: string = 'ROLE_KANRI_ORG_READ';

    /** 発注者ログイン */
    export const ORDER_LOGIN = KANRI_URL + '/login';

    /** API実行結果　正常 */
    export const API_RESULT_SUCCES: string = '0';
    /** API実行結果　異常 */
    export const API_RESULT_ERROR: string = '1';
    /** APIメソッド　GET */
    export const API_METHOD_GET: string = 'GET';
    /** APIメソッド　PUT */
    export const API_METHOD_PUT: string = 'PUT';
    /** APIメソッド　POST */
    export const API_METHOD_POST: string = 'POST';
    /** APIメソッド　DELETE */
    export const API_METHOD_DELETE: string = 'DELETE';

    /** グループレイアウトN個入力 */
    export const GROUP_LAYOUT_ARRAY: string = 'array';
    /** グループレイアウトlist入力 */
    export const GROUP_LAYOUT_LIST: string = 'list';
}

